export const getPracticeAbbrev = (practice) => {
  switch (practice) {
    case "Finance":
      return "FIN";
    case "Human Resources":
      return "HR";
    case "Information Technology":
      return "IT";
    case "Management Consulting":
      return "MC";
    case "Operations":
      return "OPS";
    case "Partner":
      return "PAR";
    case "Talent Acquisition":
    case "Talent Attraction":
      return "TA";
    case "Talent Development":
      return "TD";
    case "Technology Solutions":
      return "TS";
    case "Experience Design":
      return "XD";
    case "Digital Platforms":
      return "DP";
    case "Digital Strategy & Delivery":
      return "DSD";
    case "Marketing Solutions":
      return "MS";
    // Old
    case "Areteans":
      return "ARE";
    case "Digital":
      return "DIG";
    case "Global Delivery Center":
      return "GDC";
    case "Global Delivery Center LATAM":
      return "GDC L";
    case "Marketing":
      return "MKT";
    default:
      return practice;
  }
};